import { Navigate } from "react-router-dom";

/**
 * `/performance-lab` has been merged into the Academy page as the
 * `#performance-lab` anchored section. Redirect any direct hits to keep
 * existing external links and search-indexed URLs working.
 */
export default function PerformanceLab() {
  return <Navigate to="/academy#performance-lab" replace />;
}
